module.exports = __webpack_public_path__ + "assets/0.1.11/img/welcome.e927a5f1.png";